/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { MappingRuleConfig } from "./MappingRuleConfig";
export const CreateMappingRulesRequest = core.serialization.list(MappingRuleConfig);
